module.exports = __webpack_public_path__ + "img/onboarding-step3.3162f00cf13370e4130c.bd038b96.png";